import type {RichTextField} from '@prismicio/client'
import cn from 'classnames'
import {DEFAULT_PADDING, PADDING_BOTTOM_CLASS, PADDING_TOP_CLASS} from 'src/common/paddingClasses'
import {CrossGlowBackground} from './CrossGlowBackground'
import {EmailCaptureField} from './EmailCaptureField'

const descriptionWidthMap: Record<string, string> = {
  'Small (432px)': 'max-w-[432px]',
  'Medium (560px)': 'max-w-[560px]',
  'Large (680px)': 'max-w-[680px]',
}

export type WithInputHubspotBlobSectionUIProps = {
  title: string
  description: string
  descriptionWidth?: string | null
  placeholder: string
  submitButtonLabel: string
  successMessage: string
  genericError: string
  checkboxLabel: RichTextField
  disclaimer: string
  hubspotPortalId: string
  hubspotFormId: string
  pageUid: string
  paddingTop?: string | null
  paddingBottom?: string | null
}

export const WithInputHubspotBlobSection = ({
  title,
  description,
  descriptionWidth,
  placeholder,
  submitButtonLabel,
  successMessage,
  genericError,
  checkboxLabel,
  disclaimer,
  hubspotPortalId,
  hubspotFormId,
  pageUid,
  paddingTop,
  paddingBottom,
}: WithInputHubspotBlobSectionUIProps) => {
  const paddingTopClass = PADDING_TOP_CLASS[paddingTop ?? DEFAULT_PADDING] ?? ''
  const paddingBottomClass = PADDING_BOTTOM_CLASS[paddingBottom ?? DEFAULT_PADDING] ?? ''

  return (
    <section
      data-slice-type="blob_section"
      data-slice-variation="withInputHubspot"
      data-nav-dark="true"
      className={cn(
        'relative flex min-h-[500px] items-center overflow-hidden bg-green-dark px-5 md:min-h-[650px] md:px-10 lg:min-h-[825px] lg:px-[120px]',
        paddingTopClass,
        paddingBottomClass,
        'max-md:!pb-24',
      )}
    >
      <CrossGlowBackground />
      <div className="relative z-10 flex w-full flex-col items-center gap-8">
        <h1 className="whitespace-pre-line text-center font-main text-40 font-medium leading-[42px] text-moss-white md:leading-tight lg:text-[72px] lg:leading-[72px]">
          {title}
        </h1>
        {description && (
          <p
            className={cn(
              'text-center font-main text-18 leading-6 text-moss-white',
              descriptionWidthMap[descriptionWidth ?? 'Small (432px)'] ?? 'max-w-[432px]',
            )}
          >
            {description}
          </p>
        )}
        <div className="flex flex-col items-center gap-3">
          <EmailCaptureField
            placeholder={placeholder}
            submitButtonLabel={submitButtonLabel}
            successMessage={successMessage}
            genericError={genericError}
            checkboxLabel={checkboxLabel}
            hubspotPortalId={hubspotPortalId}
            hubspotFormId={hubspotFormId}
            pageUid={pageUid}
          />
          {disclaimer && (
            <p className="text-center font-main text-12 font-semibold uppercase tracking-[0.6px] text-moss-white/70">
              {disclaimer}
            </p>
          )}
        </div>
      </div>
    </section>
  )
}
